@use "../../../src/styles/Colors.scss" as Colors;
@use "../../../src/styles/Constants.scss" as Constants;

$var-dropzone-height: 80px;

.dropzone-element {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	height: $var-dropzone-height;
	border: 2px dashed Colors.$col-greyConnection;
	color: Colors.$col-greyFontLight;
	width: 100%;


	&--disabled {
		cursor: no-drop;
	}

	&--column {
		flex-flow: column nowrap;
	}
	
	&__text {
		margin-left: Constants.$val-spacing-m;
		margin-right: Constants.$val-spacing-m;
		
		&__bold {
			color: Colors.$col-black;
			font-weight: bold;
		}
		
		&__types {
			color: Colors.$col-greyFontLight;
			font-size: smaller;
		}
	}
	
	&__error {
		color: Colors.$col-red;
	}

	&__uploading-icon {
		[class^="icon-upload"] {
			color: Colors.$col-black;
			font-size: Constants.$val-icon48;
		}
	}
}

.progress-bar {
	background-color: Colors.$col-blueBorder;
}
